// extracted by mini-css-extract-plugin
export default {"badge":"AgentStatus_badge__lKZiT"};